import React, { useState, useEffect } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { FormattedMessage } from 'react-intl';

import Link from '/src/components/LocalizedLink';

import useLocale from '../hooks/useLocale';

import config from '../constants/site-config';
import { getLocalizedUrl } from '../locales/utils';

import imageLogo from '../assets/images/Logo.png';
import iconMenu from '../assets/images/menu.svg';
import iconClose from '../assets/images/close.svg';
import IconYellowArrow from '../assets/images/yellow-arrow.inline.svg';
import IconArrowDown from '../assets/images/svg/arrow-down-header.inline.svg';
import imageEnglishFlag from '../assets/images/header-icons/flag_United Kingdom.png';
import imageSpanishFlag from '../assets/images/header-icons/flag_Espana.png';

const Header = ({ locale, location }) => {
  const [isOpenMobileMenu, setStateMobileMenu] = useState(false);

  const handleStateMobileMenu = () => {
    setStateMobileMenu(!isOpenMobileMenu);

    const body = document.querySelector('body');
    if (isOpenMobileMenu) {
      body.style.overflow = 'auto';
    } else {
      body.style.overflow = 'hidden';
    }
  };

  useEffect(() => {
    if (!isOpenMobileMenu) {
      const body = document.querySelector('body');
      body.style.overflow = 'auto';
    }
  }, [isOpenMobileMenu]);

  const getCurrentLangFlag = () => {
    switch (locale) {
      case config.locales[1]:
        return imageEnglishFlag;
      case config.locales[0]:
        return imageSpanishFlag;
    }
  };

  return (
    <header className={`header ${isOpenMobileMenu ? 'header--mobile' : ''}`}>
      <div className="header__banner">
        <FormattedMessage id={'url.brexit-guide.index'}>
          {(link) => (
            <Link to={link[0]} id="google-optimizer-header-btn" className="btn btn--white">
              <FormattedMessage id={'menu.brexit-guide'} /> <IconYellowArrow />
            </Link>
          )}
        </FormattedMessage>

        {/* <a href="/brexit-guide" id="google-optimizer-header-btn" className="btn btn--white">
          Download your free Brexit Guide <IconYellowArrow />
        </a> */}
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="header__wrapper">
              <div className="header__logo">
                <Link to="/">
                  <img src={imageLogo} alt="logo" />
                </Link>
              </div>
              <div className="header__primary-nav">
                <nav className="primary-nav">
                  <HeaderMenu isOpenMobileMenu={isOpenMobileMenu} />
                </nav>
              </div>

              <div className="header__secondary-nav">
                {/* <ul className="primary-nav__list lang-switcher">
                  <li className="primary-nav__item primary-nav__item--hover--lvl-1">
                    <div>
                      <span className="primary-nav__link">
                        <img src={getCurrentLangFlag()} alt={`${locale} flag`} />
                        {locale.toUpperCase()}{' '}
                        <i>
                          <IconArrowDown />
                        </i>
                      </span>
                    </div>
                    <div className="primary-nav__dropdown primary-nav__dropdown--lvl-1">
                      <ul>
                        <li>
                          <GatsbyLink to={getLocalizedUrl(config.locales[1], location)}>
                            English
                          </GatsbyLink>
                        </li>
                        <li>
                          <GatsbyLink to={getLocalizedUrl(config.locales[0], location)}>
                            Spanish
                          </GatsbyLink>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul> */}

                <FormattedMessage id={'url.apply.index'}>
                  {(link) => (
                    <Link className="c-btn c-btn--red" to={link[0]}>
                      <FormattedMessage id={'menu.applyNow'} />
                    </Link>
                  )}
                </FormattedMessage>
              </div>
              <div className="header__mobile-btn" onClick={handleStateMobileMenu}>
                <img src={isOpenMobileMenu ? iconClose : iconMenu} alt="icon" />
              </div>
            </div>

            {isOpenMobileMenu && (
              <div className="header__mobile">
                <div className="header__mobile__primary-nav">
                  <nav className="primary-nav">
                    <HeaderMenu isOpenMobileMenu={isOpenMobileMenu} />
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

const HeaderMenu = ({ isOpenMobileMenu }) => {
  const { enLocale } = useLocale({ matchPathName: '/es/' });

  return (
    <ul className="primary-nav__list">
      <li className="primary-nav__item primary-nav__item--hover--lvl-1">
        <div>
          <span className="primary-nav__link">
            <FormattedMessage id={'menu.teflCourses'} />
          </span>
          <i>
            <IconArrowDown />
          </i>
        </div>
        <div className="primary-nav__dropdown primary-nav__dropdown--lvl-1">
          <ul>
            <li className="primary-nav__item--hover--lvl-2">
              <span className="primary-nav__text">
                <div>Trinity CertTESOL</div>
                <i className="primary-nav__arrow">
                  <IconArrowDown />
                </i>
              </span>
              <div className="primary-nav__dropdown primary-nav__dropdown--lvl-2">
                <ul>
                  <li>
                    <FormattedMessage id={'url.courses.one-month-160-hour-tefl-course.index'}>
                      {(link) => (
                        <Link to={link[0]}>Trinity CertTESOL: 4 weeks intensive in Barcelona</Link>
                      )}
                    </FormattedMessage>
                  </li>
                  <li>
                    <FormattedMessage id={'url.courses.online-trinity-certtesol-tefl-course'}>
                      {(link) => <Link to={link[0]}>Trinity CertTESOL: 12 weeks 100% online</Link>}
                    </FormattedMessage>
                  </li>
                </ul>
              </div>
            </li>
            {/* <li>
            <FormattedMessage id={'url.courses.online-trinity-certtesol-tefl-course'}>
              {(link) => (
                <Link to={link[0]}>
                  <FormattedMessage id={'menu.onlineTrinity'} />
                </Link>
              )}
            </FormattedMessage>
          </li> */}

            {/* <li>
            <Link to="/blended-trinity-cert-tesol-course/">Blended Trinity CertTESOL Course</Link>
          </li> */}
            <li>
              <FormattedMessage id={'url.courses.tefl-work-and-placement'}>
                {(link) => <Link to={link[0]}>TEFL & Work Placement</Link>}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.courses.tefl-spanish'}>
                {(link) => <Link to={link[0]}>TEFL & Spanish</Link>}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.teaching-kids-course'}>
                {(link) => <Link to={link[0]}>TEFL & Kids</Link>}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.courses.tefl-adventure'}>
                {(link) => <Link to={link[0]}>TEFL & Adventure</Link>}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.gap-year-program'}>
                {(link) => <Link to={link[0]}>TEFL Gap Year</Link>}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.tefl-spanish-course-barcelona'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.developingTeacher&Spanish'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>

            {/* <li>
              <FormattedMessage id={'url.courses.developing-teacher-course'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.developingTeacher'} />
                  </Link>
                )}
              </FormattedMessage>
            </li> */}

            {enLocale && (
              <>
                {/* <li>
                  <FormattedMessage id={'url.teaching-kids-course'}>
                    {(link) => (
                      <Link to={link[0]}>
                        <FormattedMessage id={'menu.teachingYoungLearners'} />
                      </Link>
                    )}
                  </FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id={'url.clases-de-ingles-economicas-barcelona.index'}>
                    {(link) => (
                      <Link to={link[0]}>
                        <FormattedMessage id={'menu.classesDeIngles'} />
                      </Link>
                    )}
                  </FormattedMessage>
                </li> */}
                <li>
                  <FormattedMessage id={'url.courses.index'}>
                    {(link) => <Link to={link[0]}>Course Comparison</Link>}
                  </FormattedMessage>
                </li>
              </>
            )}
          </ul>
        </div>
      </li>
      {/* <li className="primary-nav__item primary-nav__item--hover--lvl-1">
        <div>
          <span className="primary-nav__link">
            <FormattedMessage id="menu.locations" />
          </span>
          <i>
            <IconArrowDown />
          </i>
        </div>
        <div className="primary-nav__dropdown primary-nav__dropdown--lvl-1">
          <ul>
            <li>
              <FormattedMessage id={'url.guide-to-living-and-teaching-english-in-barcelona'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.barcelona'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.guide-to-living-and-teaching-english-in-seville'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.seville'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
          </ul>
        </div>
      </li> */}
      <li className="primary-nav__item primary-nav__item--hover--lvl-1">
        <div>
          <span className="primary-nav__link">
            <FormattedMessage id="menu.dates&fees" />
          </span>
          <i>
            <IconArrowDown />
          </i>
        </div>
        <div className="primary-nav__dropdown primary-nav__dropdown--lvl-1">
          <ul>
            <li>
              <FormattedMessage id={'url.courses.dates.index'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.dates'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.courses.tefl-course-payment-plan'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.paymentPlan'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.courses.dates.special-offers'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.specialOffers'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
          </ul>
        </div>
      </li>
      {/* <li className="primary-nav__item">
      <Link className="primary-nav__link" to="/covid/">
        Covid 19
      </Link>
    </li> */}
      <li className="primary-nav__item primary-nav__item--hover--lvl-1">
        <div>
          <span className="primary-nav__link">
            <FormattedMessage id="menu.work&Visas" />
          </span>
          <i>
            <IconArrowDown />
          </i>
        </div>
        <div className="primary-nav__dropdown primary-nav__dropdown--lvl-1">
          <ul>
            <li>
              <FormattedMessage id={'url.working-as-a-teacher.careers-service'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.carrerService'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            {/* <li>
            <Link to="/brexit-guide">Brexit Guide</Link>
          </li> */}
            <li>
              <FormattedMessage id={'url.working-as-a-teacher.student-visas'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.studentsVisas'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.accommodation'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.accommodation'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.guide-to-living-and-teaching-english-in-barcelona'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.barcelona'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.tefl-teaching-resources'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.resources'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
          </ul>
        </div>
      </li>
      <li className="primary-nav__item primary-nav__item--hover--lvl-1">
        <div>
          <span className="primary-nav__link">
            <FormattedMessage id="menu.about" />
          </span>
          <i>
            <IconArrowDown />
          </i>
        </div>
        <div className="primary-nav__dropdown primary-nav__dropdown--lvl-1">
          <ul>
            <li>
              <FormattedMessage id={'url.about.index'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.teflIberiaStory'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.about.what-is-tefl-and-how-does-it-work'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.whatIsTefl'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.about.accreditation'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.accreditations'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.about.team'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.meetTheTeam'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.about.graduates'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.teflIberiaGraduates'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.working-as-a-teacher.work-with-us'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.workWithUs'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage
                id={'url.courses.one-month-160-hour-tefl-course.entry-requirements'}
              >
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.entryRequirements'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
            <li>
              <FormattedMessage id={'url.courses.faq'}>
                {(link) => (
                  <Link to={link[0]}>
                    <FormattedMessage id={'menu.faqs'} />
                  </Link>
                )}
              </FormattedMessage>
            </li>
          </ul>
        </div>
      </li>
      {/* <li className="primary-nav__item primary-nav__item--hover--lvl-1">
      <div>
        <span className="primary-nav__link">FAQs</span>
        <i>
          <IconArrowDown />
        </i>
      </div>
      <div className="primary-nav__dropdown primary-nav__dropdown--lvl-1">
        <ul>
          <li>
            <Link to="/courses/faq">All FAQs</Link>
          </li>
          <li>
            <Link to="/courses/one-month-160-hour-tefl-course/entry-requirements">
              Entry Requirements
            </Link>
          </li>
          <li>
            <Link to="/apply/how-to-make-a-good-application">How To Make a Good Application</Link>
          </li>
          
        </ul>
      </div>
    </li> */}
      {enLocale && (
        <li className="primary-nav__item">
          <FormattedMessage id={'url.blog'}>
            {(link) => (
              <Link className="primary-nav__link" to={link[0]}>
                <FormattedMessage id={'menu.blog'} />
              </Link>
            )}
          </FormattedMessage>
        </li>
      )}
      <li className="primary-nav__item">
        <FormattedMessage id={'url.contact.index'}>
          {(link) => (
            <Link className="primary-nav__link" to={link[0]}>
              <FormattedMessage id={'menu.contact'} />
            </Link>
          )}
        </FormattedMessage>
      </li>
      {isOpenMobileMenu && (
        <li className="primary-nav__item">
          <FormattedMessage id={'url.apply.index'}>
            {(link) => (
              <Link className="primary-nav__link" to={link[0]}>
                <FormattedMessage id={'menu.applyNow'} />
              </Link>
            )}
          </FormattedMessage>
        </li>
      )}
    </ul>
  );
};

export default Header;
